import { ApolloError, gql, useQuery } from '@apollo/client';
import { GetActiveVisitTypesQuery } from './__generated__/useVisitTypes.generated';

export const VISIT_TYPES_QUERY = gql`
  query GetActiveVisitTypes($locationId: String) {
    getActiveVisitTypesForOrg(locationId: $locationId)
  }
`;

type UseVisitTypes = {
  visitTypes: string[];
  loading: boolean;
  error?: ApolloError;
  refetch: () => void;
};

export const useVisitTypes = (
  locationId: string | undefined
): UseVisitTypes => {
  const { data, loading, error, refetch } = useQuery<GetActiveVisitTypesQuery>(
    VISIT_TYPES_QUERY,
    {
      notifyOnNetworkStatusChange: true,
      fetchPolicy: 'cache-and-network',
      variables: { locationId },
      skip: !locationId,
    }
  );

  return {
    visitTypes: data?.getActiveVisitTypesForOrg ?? [],
    loading,
    error,
    refetch,
  };
};
